var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1775 4.79863L20.8122 17.8326C21.3425 18.738 20.6869 19.875 19.6346 19.875H4.36538C3.31312 19.875 2.65755 18.738 3.18783 17.8326L10.8225 4.79863C11.3486 3.90046 12.6514 3.90046 13.1775 4.79863ZM11.867 5.77862C11.8273 5.80153 11.7942 5.83432 11.7711 5.87376L4.59637 18.1227C4.52294 18.248 4.56589 18.4087 4.6923 18.4815C4.73269 18.5047 4.77856 18.517 4.82526 18.517H19.1747C19.3209 18.517 19.4394 18.3995 19.4394 18.2545C19.4394 18.2082 19.4271 18.1627 19.4036 18.1227L12.2289 5.87376C12.1555 5.7484 11.9935 5.7058 11.867 5.77862ZM12 15.9375C12.466 15.9375 12.8438 16.3153 12.8438 16.7812C12.8438 17.2472 12.466 17.625 12 17.625C11.534 17.625 11.1562 17.2472 11.1562 16.7812C11.1562 16.3153 11.534 15.9375 12 15.9375ZM11.9735 8.94C12.339 8.94 12.6353 9.23381 12.6353 9.59625V14.5837C12.6353 14.9462 12.339 15.24 11.9735 15.24C11.608 15.24 11.3118 14.9462 11.3118 14.5837V9.59625C11.3118 9.23381 11.608 8.94 11.9735 8.94Z",
    fill: "#AE0A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageError);
export default __webpack_public_path__ + "static/media/message-error.30274caa375d219c98527cf822dede8b.svg";
export { ForwardRef as ReactComponent };